import { NgModule } from '@angular/core';
import { SanitizerPipe } from './sanitizer.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        SanitizerPipe
    ],
    exports: [
        SanitizerPipe
    ]
})

export class SanitizerPipeModule { }
